import React from 'react';
import cx from 'classnames';

import { makeStyles, Typography, TypographyProps } from '@material-ui/core';

import type { Theme } from '../../../types/common.types';

const useStyle = makeStyles((theme: Theme) => {
  return {
    notification: {
      color: theme.palette.text.danger,
    },
  };
});

export const DangerText: React.FC<TypographyProps> = ({ className, ...props }) => {
  const classes = useStyle();

  return <Typography className={cx(classes.notification, className)} {...props} />;
};
